import { render, staticRenderFns } from "./ContactsBox.vue?vue&type=template&id=7fe48bbc&scoped=true"
import script from "./ContactsBox.vue?vue&type=script&lang=ts"
export * from "./ContactsBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe48bbc",
  null
  
)

export default component.exports